import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "embed-responsive embed-responsive-16by9" };
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    class: "text-center pt-0 mb-1",
    style: { "margin-top": "-10px" }
};
const _hoisted_4 = ["href"];
const _hoisted_5 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        infoPayload: _ctx.infoPayload,
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.open) = $event)),
        cancelBtnTxt: _ctx.neverClose ? '' : 'Ok',
        actionBtnTxt: "",
        onOnClosed: _ctx.onClosed,
        variant: _ctx.variant,
        onOnUserArgChanged: _ctx.onUserArgChanged,
        onOnPopupDone: _ctx.onPopupDone,
        modalWidth: "xl"
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("iframe", {
                    ref: "iframe",
                    class: "embed-responsive-item",
                    style: { "width": "100%", "border": "0.5px solid black" },
                    credentialless: "",
                    src: 'https://www.youtube.com/embed/' + _ctx.youtubeID,
                    title: "YouTube video player",
                    frameborder: "0",
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                    allowfullscreen: ""
                }, null, 8, _hoisted_2),
                _createElementVNode("p", _hoisted_3, [
                    _createElementVNode("small", null, [
                        _createElementVNode("a", {
                            href: 'https://www.youtube.com/watch?v=' + _ctx.youtubeID,
                            target: "_blank"
                        }, "Watch on Youtube", 8, _hoisted_4)
                    ])
                ])
            ]),
            _createElementVNode("p", {
                style: { "overflow": "hidden", "text-overflow": "ellipsis" },
                innerHTML: _ctx.message
            }, null, 8, _hoisted_5)
        ]),
        _: 1
    }, 8, ["infoPayload", "modelValue", "cancelBtnTxt", "onOnClosed", "variant", "onOnUserArgChanged", "onOnPopupDone"]));
}
